import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'en/home', pathMatch: 'full' },
  {
    path: ':lang',
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'aboutus',
        loadChildren: () =>
          import('./pages/aboutus/aboutus.module').then((m) => m.AboutusModule),
        pathMatch: 'full',
      },
      {
        path: 'contactus',
        loadChildren: () =>
          import('./pages/contactus/contactus.module').then(
            (m) => m.ContactusModule,
          ),
        pathMatch: 'full',
      },
      {
        path: 'services',
        loadChildren: () =>
          import('./pages/services/services.module').then(
            (m) => m.ServicesModule,
          ),
        pathMatch: 'full',
      },
      {
        path: 'subsidiaries',
        loadChildren: () =>
          import('./pages/subsidiaries/subsidiaries.module').then(
            (m) => m.SubsidiariesModule,
          ),
        pathMatch: 'full',
      },
      {
        path: 'equipment',
        loadChildren: () =>
          import('./pages/equipment/equipment.module').then(
            (m) => m.EquipmentModule,
          ),
        pathMatch: 'full',
      },
    ],
  },

  { path: '', redirectTo: 'en/home', pathMatch: 'full' },
  { path: '**', redirectTo: 'en/home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
